/**
 * Custom module for RUT
 */
export class RUT {
    public static applyBackendFormat(rut: string): string {
        const dv = rut[rut.length - 1];
        const rutWithoutDV = rut.slice(0, rut.length - 1);
        return `${rutWithoutDV}-${dv}`;
    }
}